import React, { useRef } from "react";
import PropTypes from "prop-types";

import SwiperCore from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import TeamCard from "components/cards/teamCard";

SwiperCore.use([Autoplay, Pagination, Navigation]);

const TestimonialsMobile = ({ testimonials }) => {
  const swiperRef = useRef(null);
  const isNoTestimonials = testimonials ? testimonials.length === 0 : true;

  if (isNoTestimonials) return <></>;

  const slidePerViewDefault = testimonials?.length === 1 ? 1 : 1.5;
  const slidePerView = testimonials?.length < 5 ? testimonials?.length : 5;

  return (
    <>
      <section className="bg-gray-lighten dark:bg-gray-dark flex flex-col items-center justify-center mx-auto relative z-10 py-6 min-h-[550px]">
        <div
          className={`w-full z-0 top-0 bottom-0 absolute right-0 left-0 bg-cover bg-no-repeat bg-center opacity-80 dark:opacity-40`}
        />

        <div className="w-11/12 absolute m-0 flex flex-col">
          <div className="flex flex-col ">
            <div className={`flex flex-col w-full justify-center pb-8 `}>
              <h1
                className="!font-light text-left text-title font-normal leading-8"
                dangerouslySetInnerHTML={{
                  __html: `${testimonials?.length} review${testimonials?.length > 1 ? "s" : ""}`
                }}
              />
            </div>
          </div>

          <div className="flex-col justify-center">
            <div className="flex flex-col w-full container mx-auto">
              <div
                className={`testimonials-swiper-container w-[calc(100vw-32px)] h-80`}
              >
                <Swiper
                  ref={swiperRef}
                  grabCursor={true}
                  centeredSlides={false}
                  slidesPerView={slidePerViewDefault}
                  spaceBetween={15}
                  loop={true}
                  className="testimonials-swiper justify-center items-center pb-14"
                  breakpoints={{
                    640: {
                      slidesPerView: slidePerView,
                      spaceBetween: 0,
                      navigation: true,
                      centeredSlides: true
                    }
                  }}
                >
                  {testimonials?.map((testimonial, idx) => {
                    const title = testimonial?.title || "Anonymous";
                    const featuredImage =
                      testimonial.testimonialReviewsFields?.thumbnailId
                        ?.gatsbyImage;
                    const sourceFallbackImage =
                      testimonial.testimonialReviewsFields?.thumbnailId
                        ?.sourceUrl;
                    const testimonialDate = testimonial.date;
                    const testimonialVideo =
                      testimonial.testimonialReviewsFields?.rvwVideoEmbed;
                    const content =
                      testimonial?.testimonialReviewsFields?.rvwOverallReview ??
                      testimonial?.content;
                    const uri = testimonial.uri;
                    return (
                      <SwiperSlide key={idx}>
                        <div
                          key={idx}
                          className="flex items-top justify-center col-span-1"
                        >
                          <TeamCard
                            sourceUrl={sourceFallbackImage}
                            title={title}
                            bgImage={featuredImage}
                            memberTitle={testimonialDate}
                            content={content}
                            uri={uri}
                            memberVideo={testimonialVideo}
                          />
                        </div>
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

TestimonialsMobile.propTypes = {
  testimonials: PropTypes.array
};

export default TestimonialsMobile;
